import clsx from 'clsx';

import type { RecordingBarV2Props } from './RecordingBarV2.types';
import classes from './RecordingBarV2.module.css';
import { Card } from '../Card';
import { LiveAudioVisualizerV2 } from '../LiveAudioVisualizerV2';
import { DotIcon, TimerClockIcon } from '../../assets/icons';
import { Text } from '../Text';

export const RecordingBarV2 = (props: RecordingBarV2Props) => {
    const { pcmChunks = [], className, hideVisualizer, timer, hideText = false } = props;

    return (
        <Card className={clsx(classes.root, className)}>
            {!hideVisualizer && <div>{ <LiveAudioVisualizerV2 pcmChunks={pcmChunks} />} </div>}
           

            {!!timer && timer <= 5 && (
                <div className={classes.timeMsg}>
                    <TimerClockIcon />
                    <Text className={classes.timeMsgText} text={timer.toString()} fontWeight="medium" size="sm" />
                </div>
            )}

            {!hideText && <div className={classes.text}>
                <DotIcon className={classes.icon} data-testid="record-icon" />
                <Text text="Recording" fontWeight="semibold" size="sm" />
            </div>}
        </Card>
    );
};

RecordingBarV2.displayName = 'RecordingBarV2';
